export default "<r-refinance-rapiflex #refinanceRapiflexRef></r-refinance-rapiflex>\n";